import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { safeAnchorHref } from '../../../lib/link';
import { cn } from '../../../lib/utils';
import { specraFocusRing } from '../ensigns/focus-ring';
import { SpecraText } from '../ensigns/typography';
const TONE = {
    neutral: 'border-[color:var(--border-control)] text-muted-foreground hover:border-foreground/40',
    success: 'border-success/40 text-success',
    info: 'border-brand/30 text-brand',
    warning: 'border-warning/40 text-warning',
    danger: 'border-danger/40 text-danger'
};
/** A numbered row of jump targets (questions, sections) coloured by their state. */ export function SpecraNumberedNav({ items, activeId, label, leadingLabel, renderLink, getItemTestId, className, ...props }) {
    return /*#__PURE__*/ _jsxs("nav", {
        "aria-label": label,
        className: cn('flex flex-wrap items-center gap-[var(--space-1-5)]', className),
        ...props,
        children: [
            leadingLabel ? /*#__PURE__*/ _jsx(SpecraText, {
                className: "mr-[var(--space-1)]",
                size: "body-ui",
                tone: "muted",
                children: leadingLabel
            }) : null,
            /*#__PURE__*/ _jsx("ol", {
                className: "m-0 flex list-none flex-wrap items-center gap-[var(--space-1-5)] p-0",
                children: items.map((item)=>{
                    const active = item.id === activeId;
                    const classes = cn('inline-flex size-[var(--component-numbered-nav-size)] items-center justify-center rounded-[var(--radius-md)] border bg-card text-[length:var(--fs-ui-caption)] font-medium tabular-nums transition-colors', active ? 'border-primary bg-primary text-primary-foreground' : TONE[item.tone ?? 'neutral'], specraFocusRing);
                    const common = {
                        'aria-label': item.title,
                        className: classes,
                        'data-testid': getItemTestId?.(item),
                        title: item.title
                    };
                    let control;
                    if (item.href) {
                        const current = active ? 'page' : undefined;
                        control = renderLink ? renderLink({
                            ...common,
                            'aria-current': current,
                            children: item.label,
                            href: item.href
                        }) : /*#__PURE__*/ _jsx("a", {
                            ...common,
                            "aria-current": current,
                            href: safeAnchorHref(item.href),
                            children: item.label
                        });
                    } else if (item.onSelect) {
                        control = /*#__PURE__*/ _jsx("button", {
                            ...common,
                            "aria-current": active ? 'true' : undefined,
                            onClick: item.onSelect,
                            type: "button",
                            children: item.label
                        });
                    } else {
                        control = /*#__PURE__*/ _jsx("span", {
                            ...common,
                            "aria-current": active ? 'true' : undefined,
                            role: "img",
                            children: item.label
                        });
                    }
                    return /*#__PURE__*/ _jsx("li", {
                        "data-item-id": item.id,
                        children: control
                    }, item.id);
                })
            })
        ]
    });
}
